/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { ChangeEvent, FC } from 'react';
import { styled } from 'linaria/react';
import { useTheme, withTheme } from '@shared/lib';
import { OldText } from '@shared/ui/atoms';
import { checkItemMap } from '@shared/config/checkboxRadioBuilder';
import { statuses, getCheckItemBgColor, getCheckItemBorderColor, getIconColor } from '@shared/lib/utils/checkboxRadioBuilder';
export interface CheckboxRadioBuilderProps extends React.HTMLAttributes<HTMLDivElement> {
  inputType: 'checkbox' | 'radio';
  checkIcon: React.ReactNode;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
  hasError: boolean;
  children: React.ReactNode | React.ReactNodeArray;
  size: keyof typeof checkItemMap;
  name: string;
  hint: string;
  value?: string | number;
  variant?: Variants;
}
export const CheckboxRadioBuilder: FC<CheckboxRadioBuilderProps> = ({
  disabled,
  hasError,
  checked,
  checkIcon,
  size,
  name,
  onChange,
  hint,
  inputType,
  children,
  id,
  value,
  variant,
  ...rest
}) => {
  const theme = useTheme();
  const {
    labelTextSize,
    checkItemSize,
    textMargin
  } = checkItemMap[size];
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };
  return <Wrapper data-testid={inputType} {...rest}>
      <Label checked={checked} disabled={disabled} hasError={hasError} variant={variant}>
        <HiddenInput type={inputType} name={name || 'defaultName'} id={id || name || 'defaultId'} checked={checked} value={value} onChange={handleChange} disabled={disabled} />

        <CheckItem variant={variant} checked={checked} checkItemSize={checkItemSize} disabled={disabled} hasError={hasError} size={size} type={inputType} theme={theme}>
          <CheckIconWrapper disabled={disabled} checked={checked} variant={variant}>
            {checkIcon}
          </CheckIconWrapper>
        </CheckItem>

        {children && <TextWrapper textMargin={textMargin} checkItemSize={checkItemSize}>
            <OldText color={variant == 'privateBanking' ? theme.colors.text.white : disabled ? theme.colors.text.tertiary : theme.colors.text.black} size={labelTextSize}>
              {children}
            </OldText>
            {hint && <HelperText size={size}>{hint}</HelperText>}
          </TextWrapper>}
      </Label>
    </Wrapper>;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wfb170s",
  propsAsIs: false
});
interface TextWrapperProps {
  type: 'checkbox' | 'radio';
  size: keyof typeof checkItemMap;
  checked: boolean;
  checkItemSize: 32 | 16 | 24;
  textMargin: 16 | 12 | 8;
  disabled: boolean;
  hasError: boolean;
  variant?: Variants;
}
const _exp = /*#__PURE__*/() => ({
  checkItemSize
}) => checkItemSize;
const _exp2 = /*#__PURE__*/() => ({
  textMargin
}) => textMargin;
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t9ehv5",
  propsAsIs: false,
  vars: {
    "t9ehv5-0": [_exp(), "px"],
    "t9ehv5-1": [_exp2(), "px"]
  }
});
const _exp3 = /*#__PURE__*/() => ({
  checked
}) => checked ? '1' : '0';
const _exp4 = /*#__PURE__*/() => ({
  variant
}) => getIconColor(variant as Variants)({});
const CheckIconWrapper = /*#__PURE__*/styled('div')({
  name: "CheckIconWrapper",
  class: "c1u2uh1h",
  propsAsIs: false,
  vars: {
    "c1u2uh1h-0": [_exp3()],
    "c1u2uh1h-1": [_exp4()]
  }
});
type CheckItemProps = Omit<TextWrapperProps, 'textMargin'> & ThemeProps;
const _exp6 = /*#__PURE__*/() => ({
  checkItemSize
}) => checkItemSize;
const _exp7 = /*#__PURE__*/() => ({
  size
}) => size === 'xs' ? '2px' : '';
const _exp8 = /*#__PURE__*/() => ({
  type,
  size
}) => type === 'radio' ? 5000 : size === 'xs' ? 4 : 6;
const _exp9 = /*#__PURE__*/() => ({
  variant,
  theme
}: CheckItemProps) => getCheckItemBgColor(variant as Variants, statuses.default, theme)({});
const _exp0 = /*#__PURE__*/() => ({
  variant,
  theme
}: CheckItemProps) => getCheckItemBorderColor(variant as Variants, statuses.default, theme)({});
export const CheckItem = /*#__PURE__*/styled('div')({
  name: "CheckItem",
  class: "cg3ru39",
  propsAsIs: false,
  vars: {
    "cg3ru39-0": [_exp6(), "px"],
    "cg3ru39-1": [_exp7()],
    "cg3ru39-2": [_exp8(), "px"],
    "cg3ru39-3": [_exp9()],
    "cg3ru39-4": [_exp0()]
  }
});
type LabelProps = Pick<TextWrapperProps, 'checked' | 'disabled' | 'hasError' | 'variant'> & ThemeProps;
const _exp1 = /*#__PURE__*/() => ({
  variant,
  disabled
}) => variant == 'privateBanking' && disabled && 0.32 || 0;
const _exp10 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'no-drop' : 'pointer';
const _exp12 = /*#__PURE__*/() => ({
  variant,
  theme
}: LabelProps) => getCheckItemBgColor(variant as Variants, statuses.hover, theme)({});
const _exp13 = /*#__PURE__*/() => ({
  variant,
  theme
}: LabelProps) => getCheckItemBorderColor(variant as Variants, statuses.hover, theme)({});
const _exp15 = /*#__PURE__*/() => ({
  variant,
  theme
}: LabelProps) => getCheckItemBgColor(variant as Variants, statuses.active, theme)({});
const _exp16 = /*#__PURE__*/() => ({
  variant,
  theme
}: LabelProps) => getCheckItemBorderColor(variant as Variants, statuses.active, theme)({});
const Label = withTheme(/*#__PURE__*/styled('label')({
  name: "Label",
  class: "l1d6sool",
  propsAsIs: false,
  vars: {
    "l1d6sool-0": [_exp1()],
    "l1d6sool-1": [_exp10()],
    "l1d6sool-2": [_exp12()],
    "l1d6sool-3": [_exp13()],
    "l1d6sool-4": [_exp15()],
    "l1d6sool-5": [_exp16()]
  }
}));
const HiddenInput = /*#__PURE__*/styled('input')({
  name: "HiddenInput",
  class: "h1cz5uyd",
  propsAsIs: false
});
interface HelperTextProps {
  size: keyof typeof checkItemMap;
}
const _exp20 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.colors.text.grey300;
const _exp21 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.family.MTSSans;
const _exp22 = /*#__PURE__*/() => ({
  theme
}: ThemeProps) => theme.font.weight.regular;
const _exp23 = /*#__PURE__*/() => ({
  size,
  theme
}) => size === 'lg' ? `${theme.font.size.xs}px` : `${theme.font.size.xxs}px`;
const _exp24 = /*#__PURE__*/() => ({
  size,
  theme
}) => size === 'lg' ? `${theme.font.lineHeight.xs}px` : `${theme.font.lineHeight.xxs}px`;
const _exp25 = /*#__PURE__*/() => ({
  size
}) => size === 'lg' ? '4px' : '0';
const HelperText = withTheme(/*#__PURE__*/styled('span')({
  name: "HelperText",
  class: "h1glajr0",
  propsAsIs: false,
  vars: {
    "h1glajr0-0": [_exp20()],
    "h1glajr0-1": [_exp21()],
    "h1glajr0-2": [_exp22()],
    "h1glajr0-3": [_exp23()],
    "h1glajr0-4": [_exp24()],
    "h1glajr0-5": [_exp25()]
  }
}));
CheckboxRadioBuilder.defaultProps = {
  checked: false,
  disabled: false,
  hasError: false,
  children: null,
  checkIcon: null,
  size: 'md',
  name: '',
  hint: '',
  onChange: () => {}
};

require("./CheckboxRadioBuilder.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CheckboxRadioBuilder.tsx");